import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EnvironmentService } from '../../../../services/environment.service';
import { CustomerService } from '../../../../services/customer.service';
import { OverlayService } from '../../../../services/overlay.service';
import { switchMap } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatStepper } from '@angular/material/stepper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  customerDummyLink = `${this.environmentService.getApiUrl()}/job/import/test/customer.csv`;
  contractDummyLink = `${this.environmentService.getApiUrl()}/job/import/test/contract.csv`;
  encodingImageLink = `${this.environmentService.getUrl()}/static/admin/encoding.png`;

  step1Form: FormGroup;
  step2Form: FormGroup;;

  previewCustomerData = null;
  previewContractData = null;
  filesUserData: File[] = [];
  filesContractData: File[] = [];
  step = 1;
  jobName = '';

  displayedColumns = ['number', 'customerNumber', 'salutation'];

  customerColumnDefs = [
    {
      name: '#',
      field: 'number'
    },
    {
      name: 'Kundennummer',
      field: 'customerNumber'
    },
    {
      name: 'Anrede',
      field: 'salutation'
    },
    {
      name: 'Titel',
      field: 'title'
    },
    {
      name: 'Vorname',
      field: 'firstName'
    },
    {
      name: 'Nachname',
      field: 'lastName'
    },
    {
      name: 'Geburtsdatum',
      field: 'birthday'
    },
    {
      name: 'Adresse',
      field: 'street'
    },
    {
      name: 'PLZ',
      field: 'postcode'
    }, {
      name: 'Ort',
      field: 'city'
    },
    {
      name: 'E-Mail',
      field: 'email'
    },
    {
      name: 'Telefon',
      field: 'phone'
    },
    {
      name: 'Mobil',
      field: 'mobile'
    }
  ];

  contractColumnDefs = [
    {
      name: '#',
      field: 'number'
    },
    {
      name: 'Kundennummer',
      field: 'customerNumber'
    },
    {
      name: 'Vertragstyp',
      field: 'contractType'
    },
    {
      name: 'Vertragsnummer',
      field: 'contractNumber'
    },
    {
      name: 'Zählernummer',
      field: 'measurePointNumber'
    },
    {
      name: 'Gültig von',
      field: 'validFrom'
    },
    {
      name: 'Gültig bis',
      field: 'validTill'
    },
    {
      name: 'Status',
      field: 'state'
    }
  ];

  customerColumns = this.customerColumnDefs.map(item => item.field);
  contractColumns = this.contractColumnDefs.map(item => item.field);

  constructor(
    private environmentService: EnvironmentService,
    private customerService: CustomerService,
    private overlayService: OverlayService,
    private auth: AuthenticationService,
    private http: HttpClient,
    private fb: FormBuilder) {
    this.step1Form = this.fb.group({
      valid: ['', [Validators.required]]
    })

    this.step2Form = this.fb.group({
      valid: ['', [Validators.required]]
    })
  }

  ngOnInit() {
  }

  downloadDummyData(index) {
    let a = window.document.createElement("a");
    if (index == 0) {
      a.href = this.customerDummyLink;
    } else if (index == 1) {
      a.href = this.contractDummyLink;
    }

    this.downloadFile(a.href).subscribe({
      next: file => {
        const contentType = 'application/csv';
        const blob = new Blob([file], { type: contentType });
        const objectUrl: string = URL.createObjectURL(blob);
        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        a.href = objectUrl;
        a.download = "Beispieldaten.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl)
      },
      error: err => {
        console.log(err)
        this.overlayService.openSnackBar("Fehler beim Download der Datei")
      }
    })
  }



  handleCustomerFileInput() {
    const file = this.filesUserData[0];
    this.customerService.uploadCustomerFile(file).pipe(
      switchMap(res => {
        this.jobName = res['jobName'];
        return this.customerService.getCustomerPlausiCheck(this.jobName);
      })
    ).subscribe({
      next: res => {
        this.previewCustomerData = new MatTableDataSource(res.slice(1, res.length));

      },
      error: err => {
        this.overlayService.openSnackBar(`Fehler beim Hochladen der Daten. Möglicherweise enthält die Datei nicht die richtige Anzahl an Spalten oder es wurde das falsche Trennzeichen verwendet.`, 'error');
        this.stepper.previous();
        this.previewCustomerData = null;
        this.filesUserData = [];
        this.step1Form.controls.valid.reset();
      }
    });
  }

  handleContractFileInput() {
    const file = this.filesContractData[0];
    this.customerService.uploadContractFile(file).pipe(
      switchMap(res => {
        return this.customerService.getContractPlausiCheck(this.jobName);
      })
    ).subscribe({
      next: res => {
        this.previewContractData = new MatTableDataSource(res.slice(1, res.length));
      },
      error:
        err => {
          this.overlayService.openSnackBar(`Fehler beim Hochladen der Daten. Möglicherweise enthält die Datei nicht die richtige Anzahl an Spalten oder es wurde das falsche Trennzeichen verwendet.`, 'error');
          this.stepper.previous();
          this.previewContractData = null;
          this.filesContractData = [];
          this.step2Form.controls.valid.reset();
        }
    });
  }


  startImport() {
    this.overlayService.openDialog('Sind Sie sich sicher?', 'Sobald der Import gestartet wurde, kann die Operation nicht mehr angehalten oder rückgängig gemacht werden!', 'Import starten').subscribe(result => {
      if (result) {
        this.customerService.startImportJob(this.jobName).subscribe({
          next: res => {
            this.overlayService.openSnackBar(`Import erfolgreich gestartet.`, 'success');
          },
          error: () => {
            this.overlayService.openSnackBar(`Fehler beim Ausführen des Import.`, 'error');
          }
        });
      }
    });
  }

  restartImport() {
    this.step = 1;
    this.jobName = '';
    this.previewCustomerData = null;
    this.previewContractData = null;
  }

  filterContractData(filterValue: string) {
    this.previewContractData.filter = filterValue.trim().toLowerCase();
  }

  filterCustomerData(filterValue: string) {
    this.previewCustomerData.filter = filterValue.trim().toLowerCase();
  }

  onSelect(event) {
    this.filesUserData = [];
    this.filesUserData.push(...event.addedFiles);
    this.step1Form.patchValue({
      valid: true
    })
  }

  onRemove(event) {
    this.filesUserData.splice(this.filesUserData.indexOf(event), 1);
    this.step1Form.controls.valid.reset();
  }


  onSelectContractData(event) {
    this.filesContractData = [];
    this.filesContractData.push(...event.addedFiles);
    this.step2Form.patchValue({
      valid: true
    })
  }

  onRemoveContractData(event) {
    this.filesContractData.splice(this.filesContractData.indexOf(event), 1);
    this.step2Form.controls.valid.reset();
  }

  downloadFile(url: String) {
    return this.auth.getcurrentUserObs().pipe(
      switchMap(token => {
        let headers = new HttpHeaders();
        headers = headers.set('X-OIDC-TOKEN', token.token);
        return this.http.get(`${url}`, { headers: headers, responseType: 'blob' })
      })
    )
  }

}